import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { noop } from 'lodash-es';
import { classNames } from '../utils/classnames';
import { MinusLine } from '../icons/minus-line';
import { PlusLine } from '../icons/plus-line';
export var InputNumber = function InputNumber(props) {
  var className = props.className,
    btnClassName = props.btnClassName,
    disabled = props.disabled,
    _props$value = props.value,
    value = _props$value === void 0 ? 1 : _props$value,
    _props$max = props.max,
    max = _props$max === void 0 ? 99 : _props$max,
    _props$min = props.min,
    min = _props$min === void 0 ? 1 : _props$min,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? noop : _props$onChange;
  return _jsxs("div", Object.assign({
    className: classNames('inline-flex items-center w-31 h-9 border border-ahaa-black-4 bg-white rounded-sm', {
      'cursor-not-allowed': disabled
    }, className),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, {
    children: [_jsx("button", Object.assign({
      className: classNames('flex items-center justify-center w-9 h-full bg-ahaa-black-6 border-none', btnClassName),
      disabled: disabled || value <= min,
      onClick: function onClick(e) {
        e.preventDefault();
        onChange(value - 1);
      }
    }, {
      children: _jsx(MinusLine, {
        className: 'w-6 h-6 text-ahaa-black-2'
      })
    })), _jsx("span", Object.assign({
      className: classNames('flex-1 flex items-center justify-center h-full text-sm text-black-1 border-l border-r border-ahaa-black-4', {
        'opacity-50': disabled
      })
    }, {
      children: value
    })), _jsx("button", Object.assign({
      className: classNames('flex items-center justify-center w-9 h-full bg-ahaa-black-6 border-none', btnClassName),
      disabled: disabled || value >= max,
      onClick: function onClick(e) {
        e.preventDefault();
        onChange(value + 1);
      }
    }, {
      children: _jsx(PlusLine, {
        className: 'w-6 h-6 text-ahaa-black-2'
      })
    }))]
  }));
};